export const filterInitialValues = {
  name: "",
  topic: "",
  bookmarked: [],
};
